import{useState as f}from"react";import{useEvent as d}from'./use-event.js';function p(e,t,u){let[l,s]=f(u),i=e!==void 0;return[i?e:l,d(r=>(i||s(r),t==null?void 0:t(r)))]}export{p as useControllable};
